import { InfoIcon } from '../../../assets';
import styles from './index.module.css';

export const SuspensionBanner = () => (
  <div className={styles.banner}>
    <InfoIcon width={20} height={20} />
    <span className={styles.text}>
      <span className={styles.label}>Access Suspended:</span>{' '}
      <span className={styles.message}>Contact MedHaul Support to restore access</span>
    </span>
  </div>
);
